import z from 'zod'

export const promoCampaignFormSchema = z.object({
	name: z.string().min(1, 'Name is required'),
	description: z.string().min(1, 'Description is required'),
	date: z
		.object({
			start: z.string().optional(),
			end: z.string().optional(),
		})
		.refine(
			(value) => Boolean(value?.start && value?.end),
			'Dates are required'
		),
	pos_ids: z.array(z.string()).min(1, 'Sales unit is required'),
	is_active: z.boolean(),
})
